import React from 'react'
import {Step} from "./Step";

// Helpers ----

function getStepStatus(stepNumber: number, activeStep: number): StepStatus {
  if (stepNumber === activeStep) return 'active';
  if (stepNumber < activeStep) return 'completed';
  return 'inactive';
}

// Types ----

export type StepStatus = 'active' | 'inactive' | 'completed';

type StepsProps = {
  activeStep: number;
  numberOfSteps: number;
}

// Component ----

function Steps({activeStep, numberOfSteps}: StepsProps) {
  return (
    <ul className='flex gap-x-5 flex-wrap'>
      {Array.from({ length: numberOfSteps }, (_, index) => (
        <Step
          key={index}
          number={index + 1}
          status={getStepStatus(index + 1, activeStep)}
        />
      ))}
    </ul>
  );
}

export {Steps};